// services/childcare/reviews.js
import { api } from "./utils";

// Submit a review
export const submitFacilityReview = async (facilityId, reviewData) => {
  try {
    const response = await api.post(
      `/childcare/facilities/${facilityId}/reviews`,
      reviewData,
    );
    return response;
  } catch (error) {
    console.error("Submit review error:", error);
    throw error;
  }
};

// Get facility reviews
export const getFacilityReviews = async (
  facilityId,
  page = 1,
  limit = 10,
  filters = {},
) => {
  try {
    const params = new URLSearchParams({ page, limit });
    if (filters.minRating) params.append("minRating", filters.minRating);
    if (filters.verifiedOnly) params.append("verifiedOnly", "true");

    const response = await api.get(
      `/childcare/facilities/${facilityId}/reviews?${params}`,
    );
    return response;
  } catch (error) {
    console.error("Get facility reviews error:", error);
    throw error;
  }
};

// Get rating summary
export const getFacilityRatingSummary = async (facilityId) => {
  try {
    const response = await api.get(
      `/childcare/facilities/${facilityId}/rating-summary`,
    );
    return response;
  } catch (error) {
    console.error("Get rating summary error:", error);
    throw error;
  }
};

// Update review
export const updateReview = async (reviewId, reviewData) => {
  try {
    const response = await api.put(
      `/childcare/reviews/${reviewId}`,
      reviewData,
    );
    return response;
  } catch (error) {
    console.error("Update review error:", error);
    throw error;
  }
};

// Delete review
export const deleteReview = async (reviewId) => {
  try {
    const response = await api.delete(`/childcare/reviews/${reviewId}`);
    return response;
  } catch (error) {
    console.error("Delete review error:", error);
    throw error;
  }
};

// Mark review as helpful
export const markReviewHelpful = async (reviewId) => {
  try {
    const response = await api.post(`/childcare/reviews/${reviewId}/helpful`);
    return response;
  } catch (error) {
    console.error("Mark review helpful error:", error);
    throw error;
  }
};

// Toggle favorite (add/remove)
export const toggleFavorite = async (facilityId) => {
  try {
    const response = await api.post(
      `/childcare/favorites/${facilityId}/toggle`,
    );
    return response;
  } catch (error) {
    console.error("Toggle favorite error:", error);
    throw error;
  }
};

// Get user's favorite facilities
export const getFavorites = async (page = 1, limit = 12) => {
  try {
    const response = await api.get(
      `/childcare/favorites?page=${page}&limit=${limit}`,
    );
    return response;
  } catch (error) {
    console.error("Get favorites error:", error);
    throw error;
  }
};

// Check if facility is favorite
export const checkFavorite = async (facilityId) => {
  try {
    const response = await api.get(`/childcare/favorites/${facilityId}/check`);
    return response;
  } catch (error) {
    console.error("Check favorite error:", error);
    throw error;
  }
};

// Get favorite status for multiple facilities
export const getBulkFavoriteStatus = async (facilityIds) => {
  try {
    const response = await api.post(`/childcare/favorites/bulk-status`, {
      facilityIds,
    });
    return response;
  } catch (error) {
    console.error("Get bulk favorite status error:", error);
    throw error;
  }
};
